"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addReducer(globalStateManager, name, reducer) {
    return globalStateManager.addReducer(name, reducer);
}
exports.default = addReducer;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/reactn/build/add-reducer.js
// module id = 142
// module chunks = 0